import { graphql } from 'src/graphql';

export const MarkAllNotificationsAsReadByTeam = graphql(`
  mutation MarkAllNotificationsAsReadByTeam($_team_id: ID!) {
    markAllNotificationsAsReadByTeam(_team_id: $_team_id) {
      _id
    }
  }
`);
